import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FiHome, FiLock, FiMapPin, FiFilter, FiCalendar, FiLogOut,
  FiChevronDown, FiChevronRight, FiMenu, FiX, FiHelpCircle,
  FiUserCheck, FiUsers, FiFolder
} from 'react-icons/fi';
import { BsBuilding } from 'react-icons/bs';
import logo2 from "../../../assets/images/logo2.png";
import { MdAnalytics, MdHistory, MdOutlineRealEstateAgent, MdSell } from 'react-icons/md';
import { FaBalanceScale, FaBars, FaBlog, FaQuestionCircle, FaRegStar, FaUserCheck, FaUsers } from 'react-icons/fa';
import '../../../assets/css/admin/adminsidebar/adminsidebar.css';
import AppContext from 'context/AppContext';

const menuItems = [
  { id: 'dashboard', label: 'Dashboard', icon: <FiHome />, path: '/admin/dashboard' },
  { id: 'sub-admin', label: 'Sub Admin', icon: <FiUserCheck />, path: '/admin/subadmin' },
  { id: 'sellers', label: 'All Sellers', icon: <MdSell />, path: '/admin/sellers' },
  { id: 'buyer', label: 'All Buyers', icon: <FaUsers />, path: '/admin/buyer' },
  { id: 'adminkyc', label: 'Verify Kyc Request', icon: <FaUserCheck />, path: '/admin/adminkyc' },
  { id: 'blogs', label: 'Blog Management', icon: <FaBlog />, path: '/admin/blogs' },
  { id: 'faqs', label: 'FAQs Management', icon: <FaQuestionCircle />, path: '/admin/faqs' },
  { id: 'contact', label: 'Contact Request', icon: <FiUsers />, path: '/admin/contact' },
  { id: 'analytics', label: 'Analytics', icon: <MdAnalytics />, path: '/admin/analytics' },
  { id: 'dispute', label: 'Help & Support', icon: <FaBalanceScale />, path: '/admin/dispute' },
  // { id: 'properties',  label: 'All Properties',        icon: <MdOutlineRealEstateAgent />,  path: '/admin/properties' },
  // { id: 'scheduling',  label: 'Scheduling & Booking',  icon: <FiCalendar />,                path: '/admin/scheduling' },
  // { id: 'ratings',     label: 'Ratings',               icon: <FaRegStar />,                 path: '/admin/ratings'    },
  // { id: 'category',    label: 'Category Management',   icon: <FiFolder />,                  path: '/admin/category'   },

];

// ── Derive active id from current URL path ────────────────────
const getActiveId = (pathname) => {
  // exact match first
  const exact = menuItems.find(m => m.path === pathname);
  if (exact) return exact.id;
  // partial match (e.g. /admin/blogs/edit → blogs)
  const partial = menuItems.find(m => pathname.startsWith(m.path) && m.path !== '/admin/dashboard');
  if (partial) return partial.id;
  // dashboard fallback
  if (pathname === '/admin' || pathname === '/admin/') return 'dashboard';
  return '';
};

const AdminSidebar = ({ isCollapsed, onToggle }) => {
  const { setAuthToken, Navigate } = useContext(AppContext);
  const location = useLocation();

  // const [isCollapsed,setIsCollapsed]=useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(true);

  // ── Active state is DERIVED from URL — single source of truth ─
  const activeMenu = getActiveId(location.pathname);

  // Close mobile sidebar on route change
  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const handleMenuClick = (path) => {
    Navigate(path);
    if (window.innerWidth < 768) setIsMobileOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('adminemail');
    localStorage.removeItem('adminpassword');
    localStorage.removeItem("loggedInAdmin");
    Navigate('/admin/auth');
  };

  useEffect(() => {
    localStorage.getItem("authToken");
    // if (authToken) {
    //   setAuthToken(authToken);
    // }
  }, []);

  return (
    <>
      {/* ── Mobile Toggle Button ── */}
      <button className="admin-mobile-menu-btn" onClick={() => setIsMobileOpen(s => !s)}>
        {isMobileOpen ? <FiX /> : <FiMenu />}
      </button>

      {/* ── Mobile Overlay ── */}
      {isMobileOpen && (
        <div className="admin-sidebar-overlay" onClick={() => setIsMobileOpen(false)} />
      )}

      {/* ── Sidebar ── */}
      <div className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}>

        {/* Logo */}
        <div className="admin-sidebar-header">
          {!isCollapsed && (
            <a href="/" className="navbar-brand">
              <img src={logo2} alt="Estate Experts" className="navbar-logo" />

              {/* Text block */}
              <div className="navbar-brand-text-wrap">
                <span className="footer-brand-text">Estate Experts</span>
                <span className="footer-brand-tagline">
                  Buy
                  <span className="brand-tagline-dot">◆</span>
                  Sell
                  <span className="brand-tagline-dot">◆</span>
                  Rent
                </span>
              </div>
            </a>
          )}
          <button
            className="admin-sidebar-hamburger"
            onClick={onToggle}
            title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            <FaBars />
          </button>
        </div>

        {/* Nav */}
        <nav className="admin-sidebar-nav">
          <ul className="admin-menu-list">
            {menuItems.map((item) => (
              <li key={item.id} className="admin-menu-item">
                <div
                  className={`admin-menu-link ${activeMenu === item.id ? 'active' : ''}`}
                  onClick={() => handleMenuClick(item.path)}
                  title={isCollapsed ? item.label : ''}
                >
                  <span className="admin-menu-icon">{item.icon}</span>
                  {!isCollapsed && (
                    <span className="admin-menu-label">{item.label}</span>
                  )}
                  {/* Active dot when collapsed */}
                  {isCollapsed && activeMenu === item.id && (
                    <span className="admin-active-dot" />
                  )}
                </div>
              </li>
            ))}
          </ul>
        </nav>

        {/* Logout */}
        <div className="admin-sidebar-footer">
          <button
            className="admin-logout-btn"
            onClick={handleLogout}
            title={isCollapsed ? 'Logout' : ''}
          >
            <span className="admin-menu-icon"><FiLogOut /></span>
            {!isCollapsed && <span className="admin-menu-label">Logout</span>}
          </button>
        </div>
      </div>
    </>
  );
};

export default AdminSidebar;